// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "textarea[data-v-e9843834]:not(\".textarea\"){border-style:none}textarea[data-v-e9843834]{display:block;height:auto;min-height:2em;width:100%}textarea[data-v-e9843834],textarea[data-v-e9843834]:focus{outline:2px solid transparent;outline-offset:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
